module.exports = __webpack_public_path__ + "img/95.8e5bc97.png";